<div class="pc-tag">
  <span class="pc-tag__text">{{ text }}</span>
</div>
